import React from 'react';
import './App.css';
import Main from './component';

function App() {
  return (
    <>
    <Main/>
    </>
  );
}

export default App;
